export default __webpack_public_path__ + "static/media/tetrahedron.4fe8ec2f.glb";